/**
 * Created by elmer on 29/06/17.
 */
import Vue from 'vue';

export function login(state, jwt) {
  state.loggedIn = true;
  Vue.set(state, 'jwt', jwt[1].token);
  Vue.set(state, 'user', jwt[0]);
  localStorage.setItem('jwt', JSON.stringify(jwt));
}

export function logout(state) {
  localStorage.removeItem('jwt');
  state.loggedIn = false;
  Vue.set(state, 'jwt', null);
  Vue.set(state, 'user', null);
  Vue.set(state, 'campaigns', []);
  Vue.set(state, 'archivos_publicidad', []);
}



// WEBPACK FOOTER //
// ./src/modules/login/login.mutations.js